// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8b1466fe","455":"90efeeab","977":"e21f0636"}[chunkId] + ".chunk.js";
};